import React from 'react';

export const UnionIcon = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.01802 1.90001C4.50811 1.90001 2.47343 3.93469 2.47343 6.4446V11.7232H11.5626V6.4446C11.5626 3.93469 9.52793 1.90001 7.01802 1.90001ZM1.17343 6.4446V11.7232H0.736365C0.37738 11.7232 0.0863647 12.0142 0.0863647 12.3732C0.0863647 12.7322 0.37738 13.0232 0.736365 13.0232H4.61534C4.61462 13.0475 4.61425 13.0718 4.61425 13.0962C4.61425 14.4238 5.69045 15.5 7.01801 15.5C8.34557 15.5 9.42177 14.4238 9.42177 13.0962C9.42177 13.0718 9.42141 13.0475 9.42069 13.0232H13.2636C13.6226 13.0232 13.9136 12.7322 13.9136 12.3732C13.9136 12.0142 13.6226 11.7232 13.2636 11.7232H12.8626V6.4446C12.8626 3.21672 10.2459 0.600006 7.01802 0.600006C3.79014 0.600006 1.17343 3.21672 1.17343 6.4446ZM8.1194 13.0232H5.91663C5.91506 13.0473 5.91425 13.0717 5.91425 13.0962C5.91425 13.7058 6.40842 14.2 7.01801 14.2C7.6276 14.2 8.12177 13.7058 8.12177 13.0962C8.12177 13.0717 8.12097 13.0473 8.1194 13.0232Z"
      fill="white"
    />
  </svg>
);
